import axios, {AxiosError, AxiosResponse} from 'axios'
import formDataAxios from './formDataAxios'
import {getAccessTokenForApi, removeAuth} from './AuthHelpers'
const API_URL = process.env.REACT_APP_API_URL
const sessionId = localStorage.getItem('sessionId')
const dataAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Headers': '*',
    'X-Session-ID': sessionId ? sessionId : '',
  },
})

// Toujours envoyer le JWT du storage sur chaque requête (évite 401 si la requête part
// avant le useEffect du Sidebar qui appelle setAuthToken — cas classique avec react-query).
dataAxios.interceptors.request.use((config) => {
  const token = getAccessTokenForApi()
  if (token) {
    const prev = config.headers
    const merged =
      typeof prev === 'object' && prev !== null && !Array.isArray(prev)
        ? {...(prev as Record<string, unknown>)}
        : {}
    config.headers = {
      ...merged,
      Authorization: `Bearer ${token}`,
    } as typeof config.headers
  }
  return config
})

dataAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    // 401 seulement : session invalide / expirée. Ne pas traiter 403 ici (rôle / droit) : sinon
    // une action non autorisée déconnecte l’utilisateur à tort.
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('expirationTime')
      removeAuth()
      window.location.reload()
    }

    return Promise.reject(error)
  }
)
export const setAuthToken = (token: string | null) => {
  if (token) {
    dataAxios.defaults.headers.common = {Authorization: `Bearer ${token}`}
    formDataAxios.defaults.headers.common = {Authorization: `Bearer ${token}`}

    localStorage.setItem('token', token)
  } else {
    delete dataAxios.defaults.headers.common['Authorization']
    delete formDataAxios.defaults.headers.common['Authorization']
    localStorage.removeItem('token')
  }
}
export default dataAxios
